<template>
  <div class="Aside">
    <template>
      <el-menu
        class="Aside__Menu"
        :router="true"
        :background-color="DefaultColor"
        :text-color="TextPrimary2"
        :active-text-color="PrimaryColor"
        :collapse="collapseMenu"
        @select="onClickMenuItem"
      >
        <el-menu-item index="1" route="/">
          <!-- <span> -->
          <i class="el-icon-odometer"></i>
          <span slot="title">首页</span>
          <!-- </span> -->
        </el-menu-item>

        <el-submenu
          index="2"
          class="submenuclass"
          v-if="isAdmin || isRoleinfo.hasPer00003"
        >
          <template slot="title">
            <i class="el-icon-reading"></i>
            <span slot="title">课程管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="2-1" route="/studyclass">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">学习班</span>
            </el-menu-item>
            <el-menu-item index="2-2" route="/course">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">课程</span>
            </el-menu-item>
            <el-menu-item index="2-3" route="/standard/scheduling">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">排课</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu
          index="5"
          class="submenuclass"
          v-if="isAdmin || isRoleinfo.hasPer00004"
        >
          <template slot="title">
            <i class="el-icon-pie-chart"></i>
            <span slot="title">报表管理</span>
          </template>
          <el-menu-item-group>
            <!-- <el-menu-item index="5-2" route="/user/vacate">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">请假审批</span>
            </el-menu-item> -->
            <el-menu-item index="5-1" route="/export/exportquick" v-show="isAdmin">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">常用导出</span>
            </el-menu-item>



            <el-menu-item index="5-2" route="/export/userclassHours">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">学时信息（学员）</span>
            </el-menu-item>

            <el-menu-item index="5-3" route="/export/schedulingHours">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">学时信息（排课）</span>
            </el-menu-item>

            <el-menu-item index="5-4" route="/export/studyclassHours">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">学时信息（学习班）</span>
            </el-menu-item>

            <el-menu-item
              index="5-5"
              route="/export/classunit"
              v-if="isAdmin || roleid == '00003'"
            >
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">学时信息（单位）</span>
            </el-menu-item>

            <el-menu-item
              index="5-6"
              route="/export/partyorg"
              v-if="isAdmin || roleid == '00002'"
            >
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">学时信息（党组织）</span>
            </el-menu-item>
          </el-menu-item-group>

        </el-submenu>

        <el-submenu
          index="6"
          class="submenuclass"
          v-if="isAdmin || isRoleinfo.hasPer00002 || isPartyManager"
        >
          <template slot="title">
            <i class="el-icon-news"></i>
            <span slot="title">审核信息</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="6-3" route="/leave/dashboard">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">请假审核</span>
            </el-menu-item>
            <el-menu-item index="6-4" route="/fillcheck">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">补签审核</span>
            </el-menu-item>
            <el-menu-item index="6-5" route="/score/supplement" v-if="isAdmin || roleid == '00001' || roleid == '00003' || isPartyManager">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">补充学时</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>


        <el-menu-item index="10" route="/user/dashboard">
          <i class="el-icon-user"></i>
          <span slot="title">学员信息维护</span>
        </el-menu-item>


        <el-submenu
          index="7"
          class="submenuclass"
          v-if="isAdmin || isRoleinfo.hasPer00005"
        >
          <template slot="title">
            <i class="el-icon-house"></i>
            <span slot="title">基础数据维护</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="7-1" route="/standard/studyclasstype">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">学习班类型</span>
            </el-menu-item>

            <el-menu-item index="7-2" route="/user">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">学员概览</span>
            </el-menu-item>

            <el-menu-item index="7-3" route="/standard/classunit">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">单位</span>
            </el-menu-item>
            <el-menu-item index="7-4" route="/standard/partyorg/dashboard">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">党组织</span>
            </el-menu-item>

            <el-menu-item index="7-5" route="/standard/fxuser">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">复兴一号（学员）信息</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu index="9" v-if="isAdmin || isRoleinfo.hasPer00001">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span slot="title">系统全局管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="9-1" route="/standard/muser/muserList">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">后台用户</span>
            </el-menu-item>
            <el-menu-item index="9-2" route="/standard/role">
              <i class="el-icon-d-arrow-right"></i>
              <span slot="title">权限</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </template>

    <div class="Aside__Footer">
      <template v-if="serverIsDev">
        <el-row v-if="!collapseMenu">正使用测试环境数据库，请注意！！！</el-row>
      </template>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :title="collapseMenu ? '' : ''"
          :icon="collapseMenu ? 'el-icon-orange' : 'el-icon-apple'"
          class="collapse__btn"
          @click="changeCollapseMenu"
          >{{ collapseMenu ? "" : "" }}</el-button
        >
      </el-row>
      <el-row>
        <el-button
          type="success"
          :icon="collapseMenu ? 'el-icon-medal' : ''"
          :title="collapseMenu ? version : ''"
          class="version__btn"
          >{{ collapseMenu ? "" : version }}</el-button
        >
      </el-row>
    </div>
  </div>
</template>

<script>

import { checkServer } from "@/api/module/login/login";
import { clearAllCache } from "@/utils/tablestorage";


export default {
  name: "AppAside",
  data() {
    return {
      version : "Version 2.4.1  © 2024",
      collapseMenu : false,
      serverIsDev : false,
          // Color
      DefaultColor : "#FFFFFF",
      PrimaryColor : "#409EFF",
      SuccessColor : "#67C23A",
      WarningColor : "#E6A23C",
      DangerColor : "#F56C6C",
      InfoColor : "#909399",

      TextPrimary : "#303133",
      TextPrimary2 : "#606266",
      TextPrimary3 : "#909399",
      TextPrimary4 : "#C0C4CC",

      BorderPrimary : "#DCDFE6",
      BorderPrimary2 : "#E4E7ED",
      BorderPrimary3 : "#EBEEF5",
      BorderPrimary4 : "#F2F6FC"
    }
  },
  methods:{
    init() {
      checkServer()
        .then((response) => {
          this.serverIsDev = response.isdev;
        })
    },

    onClickMenuItem(val){
      clearAllCache();
    },


    changeCollapseMenu(){
      // this.collapseMenu = !this.collapseMenu;
      // this.$emit("DoCollapse");
    }
  },
  computed:{
    isAdmin(){
      return this.$store.getters["profileModule/isadmin"];
    },
    isRoleinfo(){
      return this.$store.getters["profileModule/roleinfos"];
    },
    isUnitManager(){
      return this.$store.getters["profileModule/isUnitManager"];
    },
    isPartyManager(){
      return this.$store.getters["profileModule/isPartyManager"];
    },
    roleid(){
      return this.$store.getters["profileModule/roleid"];
    }
  },

  mounted(){
    this.init();

    console.log("role infos ", this.$store.getters)

  }
}


</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
